import React, { useCallback } from 'react';
import { SettingsSection } from 'design-system';
import { IconArrowBack } from 'design-system/icons';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import useOpenSubscription from 'features/subscriptions/hooks/useOpenSubscription';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { formatPlural } from 'utils';
import { selectShouldShowRecurringPayments } from '../selectors';
const RecurringPaymentsItem = ({ account }) => {
    const navigation = useMainStackNavigation();
    const shouldShow = useAppSelector(selectShouldShowRecurringPayments);
    const openSubscription = useOpenSubscription();
    const payments = account.recurringPayments;
    const count = payments?.length ?? 0;
    const onPress = useCallback(() => {
        if (!payments?.length)
            return;
        if (payments.length === 1) {
            openSubscription(payments[0].subscriptionId);
            return;
        }
        navigation.navigateDeprecated('Subscriptions');
    }, [navigation, openSubscription, payments]);
    if (!shouldShow || !count)
        return null;
    return (<SettingsSection midMarginTop>
      <SettingsItemNavigate title={`View recurring ${formatPlural('payment', 'payments', count)}`} icon={<IconArrowBack gradientKey="darkPink"/>} onPress={onPress}/>
    </SettingsSection>);
};
export default React.memo(RecurringPaymentsItem);
